import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import merchants from "../../models/merchants";
import helpers from "../../helpers/common";
import referrals from "../../models/referrals";
import currencies from "../../models/currencies";
import MerchantForm from "./MerchantForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function MerchantAdd(props) {
    const [searchParams] = useSearchParams();
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});
    const [referralsData, setReferralsData] = useState([]);
    const [currenciesData, setCurrenciesData] = useState([]);

    const defaultFields = {
        ...(searchParams.get('project_id') ? {project_id: parseInt(searchParams.get('project_id'))} : {}),
        checkout_mode: 'redirect_checkout'
    }
    const [fields, setFields] = useState(defaultFields)

    useEffect(() => {
        referrals.index({enabled: true})
            .then((data) => {
                const list = data?.referrals || [];
                setReferralsData(list);
            })
            .catch(() => setReferralsData([]));

        currencies.index()
            .then((data) => {
                const list = Array.isArray(data) ? data.filter((c) => c.enabled) : [];
                setCurrenciesData(list);
            })
            .catch(() => setCurrenciesData([]));
    }, []);

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof merchants.fieldValidator[name] === 'function'
        && merchants.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = merchants.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        merchants.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/merchants')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add merchant" breadcrumbs={[['Dashboard', '/'], ['Merchants', '/merchants'], ['Add', '/merchants/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <MerchantForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit}
                              referralsData={referralsData}
                              currenciesData={currenciesData} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}